import React from "react";
import {
  MODULE_ACL_SWITCH,
  ACL_MODULE_MAPPING,
} from "../../../constants/RouteConstant";
import { app_path } from "config";

export const getEnabledModules = (accountReducer) => {
  let moduleAclArray =
    (accountReducer &&
      accountReducer.moduleAcl &&
      accountReducer.moduleAcl.map((item) => item.module_id)) ||
    [];
  let xoxoPointVoucherTitle = "";
  xoxoPointVoucherTitle = moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_POINT)
    ? "Points"
    : "";
  if (
    moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
    moduleAclArray.includes(ACL_MODULE_MAPPING.MAGIC_VOUCHER)
  ) {
    xoxoPointVoucherTitle
      ? (xoxoPointVoucherTitle += "/Code")
      : (xoxoPointVoucherTitle = "Code");
  }

  if (MODULE_ACL_SWITCH == false) {
    xoxoPointVoucherTitle = "";
  }

  let typeData =
    accountReducer && accountReducer.typeData ? accountReducer.typeData : {};
  let walletThree = 1;
  if (typeData.walletCompany && typeData.walletCompany == 1) {
    walletThree = 0;

    moduleAclArray.includes(ACL_MODULE_MAPPING.WALLET)
      ? xoxoPointVoucherTitle
        ? (xoxoPointVoucherTitle += "/Tokens")
        : (xoxoPointVoucherTitle = "Tokens")
      : null;

    moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO) ||
    moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO_API)
      ? xoxoPointVoucherTitle
        ? (xoxoPointVoucherTitle += "/Plum Pro")
        : (xoxoPointVoucherTitle = "Plum Pro")
      : null;

    moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK)
      ? xoxoPointVoucherTitle
        ? (xoxoPointVoucherTitle += "/Link")
        : (xoxoPointVoucherTitle = "Link")
      : null;
  }

  xoxoPointVoucherTitle
    ? (xoxoPointVoucherTitle = "Xoxo " + xoxoPointVoucherTitle + " Fund")
    : null;

  const modulesList = [
    {
      enable:
        MODULE_ACL_SWITCH == false ||
        moduleAclArray.includes(ACL_MODULE_MAPPING.EMPULS),
      redirect: `/${app_path}/reports/empuls-report/`,
    },
    {
      enable:
        (MODULE_ACL_SWITCH == false || xoxoPointVoucherTitle) && walletThree,
      redirect: `/${app_path}/reports/voucher-recharge/`,
    },
    {
      enable:
        (MODULE_ACL_SWITCH == false ||
          moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO) ||
          moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO_API) ||
          moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK)) &&
        walletThree,
      redirect: `/${app_path}/reports/plum-pro-report/`,
    },
    {
      enable:
        walletThree == 0 &&
        (MODULE_ACL_SWITCH == false || xoxoPointVoucherTitle),
      redirect: `/${app_path}/reports/xoxo-token-report/`,
    },
    {
      enable:
        MODULE_ACL_SWITCH == false ||
        (moduleAclArray.includes(ACL_MODULE_MAPPING.PERKS) &&
          this.state?.perksHistoryCount > 0),
      redirect: `/${app_path}/reports/perks-report/`,
    },
  ];

  const enabledModules = modulesList?.filter((module) => module.enable);
  return { enabledModules, xoxoPointVoucherTitle, walletThree };
};
